import type { User } from '../types';

export function isCreditOnlyBilling(user?: Pick<User, 'billingMode'> | null): boolean {
    return user?.billingMode === 'credit_only';
}

export function formatWalletMinor(minor: number, currency: 'EUR' | 'USD'): string {
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
    }).format(minor / 100);
}
